import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose, lifecycle, withHandlers, withProps, withPropsOnChange } from 'recompose';

import MatchesTable from './MatchesTable';
import withMatches from './withMatches';
import withShopifySettings from '../../withShopifySettings';
import withShopifyState from '../../withShopifyState';
import { CONNECT, INTEGRATIONS_PATH, SETTINGS } from '../../../../../main/settings/integrations/constants';
import generateMatchesColumns from './generateMatchesColumns';
import { resetMatches, resetSelectedItems, setAllSelected, setSelectedItems } from '../../reducer/actions';


const mapStateToProps = state => ({
  allSelected: state.shopify.shopifyMatches.allSelected,
  count: state.shopify.shopifyMatches.pagination.count,
  loadingMatches: state.shopify.shopifyMatches.loading,
  selectedItems: state.shopify.shopifyMatches.selectedItems,
});

const mapDispatchToProps = {
  setAllSelected,
  setSelectedItems,
  resetMatches,
  resetSelectedItems,
};

export default compose(
  withShopifySettings,
  withShopifyState,
  connect(mapStateToProps, mapDispatchToProps),
  withMatches,
  withRouter,
  withHandlers({
    isSelected: props => item => props.selectedItems.includes(item.productId),
  }),
  withHandlers({
    onChange: props => (item) => {
      if (props.isSelected(item)) {
        props.setSelectedItems(props.selectedItems.filter(itemSelected => itemSelected !== item.productId));
      } else {
        props.setSelectedItems([...props.selectedItems, item.productId]);
      }
    },
    onSelectAll: props => () => {
      const allSelected = !props.allSelected;
      const selectedItems = allSelected ? props.matches.map(item => item.productId) : [];

      props.setAllSelected(allSelected, selectedItems);
    },
  }),
  withPropsOnChange(['shopifyConnectionState'], (props) => {
    if (props.shopifyConnectionState === CONNECT || props.shopifyConnectionState === SETTINGS) {
      props.router.replace(`${props.baseUrl}${INTEGRATIONS_PATH}/shopify`);
    }
  }),
  withProps(props => ({
    noMatches: props.matchesInitialized && !props.loadingMatches && !props.count,
  })),
  withPropsOnChange(
    ['allSelected', 'isSelected', 'matchesInitialized', 'noMatches', 'onChange', 'onSelectAll', 'selectable'],
    ({ allSelected, isSelected, noMatches, onChange, onSelectAll, selectable, matchesInitialized }) => {
      const columns = generateMatchesColumns({
        allSelected,
        isSelected,
        matchesInitialized,
        noMatches,
        onChange,
        onSelectAll,
        selectable,
      });

      return {
        columns,
      };
    }),
  lifecycle({
    componentWillUnmount() {
      this.props.resetSelectedItems();
    },
  }),
)(MatchesTable);
